export const PROFILE_ATTRIBUTE_VALUE_MISSING = 'VALUE_MISSING';
export const PROFILE_ATTRIBUTE_VALUE_MISSING_LABEL = '∅ Missing';

export const toDisplayValue = value =>
  value === PROFILE_ATTRIBUTE_VALUE_MISSING ? PROFILE_ATTRIBUTE_VALUE_MISSING_LABEL : value;

export const toInternalValue = value =>
  value === PROFILE_ATTRIBUTE_VALUE_MISSING_LABEL ? PROFILE_ATTRIBUTE_VALUE_MISSING : value;
